// File: src/config/teamConfig.js

export const CORE_TEAM = [
  {
    id: 'john-ashbee',
    name: 'John Ashbee',
    title: 'Chair',
    image: '/images/team/john-ashbee.png',
    linkedin: null,
    bio: [
      'John Ashbee, Chair, has held management positions with several private and public companies, most recently, reWorks Inc. John has for a number of years been involved in promoting start-up ventures employing vermicasting technology. He is active in promoting corporate sustainability with a particular emphasis on supporting sustainable agricultural production.',
      'After a career that has taken him to the UK, Australia, South Africa, and the US, Mr. Ashbee brings extensive knowledge of soil amendments distribution, marketing, and the capital markets to GreenScience.',
      'John graduated from Ryerson University (now known as TMU) as a Mechanical Technologist with an Aeronautic specialty. John extends his commitment to environmental awareness by lecturing at the high school level and Universities. Most recently a member of the City of Toronto Circular Economy Working Group.',
    ],
  },
  {
    id: 'thomas-christiansen',
    name: 'Thomas Christiansen',
    title: 'President',
    image: '/images/team/thomas-christiansen.png',
    linkedin: null,
    bio: [
      'Thomas Christiansen is President of GreenScience and leads the company\'s commercial strategy, business development, partnerships, customer acquisition, and operating growth.',
      'Thomas has spent more than 20 years building revenue, leading teams, managing customers, and turning business opportunities into working commercial models. His background includes business-to-business sales, branch leadership, P&L ownership, sales management, service coordination, customer retention, margin performance, and operational oversight.',
      'That experience matters at GreenScience because the company is not just selling an environmental idea. It is building an operating business around sustainable soil products, worm castings, organic waste diversion, and circular agriculture. That requires customers, partners, supply discipline, reliable execution, and a clear path to repeatable revenue.',
      'Thomas brings a practical operator\'s mindset to that work. He has built and managed sales teams across regional and national markets, developed senior-level customer relationships, created strategic partnerships, and worked with structured expansion models including franchising and Area Development networks. His focus is on building GreenScience into a credible commercial platform: one that can serve growers, producers, landscapers, municipalities, and organizations looking for better soil outcomes and better organic waste solutions.',
      'Thomas is a graduate of Seneca College, where he earned a three-year diploma in International Business.',
    ],
  },
  {
    id: 'darryl-peck',
    name: 'D. Darryl R. Peck',
    title: 'HonBSc, CFRE, CGE-RS — VP Corporate Sustainable Responsibility & Community Engagement',
    image: '/images/team/darryl-peck.png',
    linkedin: null,
    bio: [
      'Darryl graduated from McGill and Guelph with a focus on Resources Planning and Management. He has worked in the public, private and charitable sectors; work that has taken him to every province and territory in this country as well as to the United States, North Korea, China, South America, Europe and South Africa.',
      'His work in the private and charitable sectors in the area of Corporate Social Responsibility and philanthropy has resulted in the creation of a number of companies, 6 national NGOs and the creation of CSR and philanthropy programs at a number of successful companies.',
      "Helping sustain and strengthen Canada's civil society through successful partnerships between private enterprises and the country's Not for Profit sector has been a passion of Mr. Peck's throughout his career. He has appeared on radio and TV, and his work has been featured in national and international publications, magazines and newspapers.",
    ],
  },
  {
    id: 'mark-barnes',
    name: 'Mark Barnes',
    title: 'MBA, C.Mgr. — Corporate Finance & Business Development Advisor',
    image: '/images/team/mark-barnes-2.png',
    linkedin: null,
    bio: [
      'Mark Barnes provides core support to growth companies seeking to raise capital, build and strengthen management, develop and implement proactive growth strategies and improve business processes.',
      'A management consultant for over 17 years, with a quarter century of entrepreneurial experience, Mr. Barnes possesses strong strategic business planning skills with proven expertise in business development, marketing, financial modeling and project management.',
      'Mark has an MBA degree from the DeGroote School of Business at McMaster University, a Diploma in Business Administration from Wilfrid Laurier University, and a BA in Economics from the University of Western Ontario. As a Chartered Manager (C.Mgr.), Mark can be relied on to provide ethical, grounded and holistic managerial services and judgement.',
    ],
  },
  {
    id: 'kai-li',
    name: 'Kai Li',
    title: 'MASc — VP of Technology',
    image: '/images/team/kai-li.png',
    linkedin: null,
    bio: [
      'Kai holds a Master of Applied Science in Chemical Engineering from the University of Waterloo. He brings over five years of experience collaborating with researchers and academic partners in national and private laboratories across materials science, air pollution control, wastewater treatment, and renewable energy.',
      'For the past 10 years, Kai has provided strategic consultation and R&D leadership to the oil & gas, waste management, and chemical manufacturing sectors. He also has more than six years of experience in project management and product delivery, working closely with executive leadership teams to drive results.',
      'A results-focused and goal-oriented leader, Kai combines technical expertise with strategic oversight to deliver high-impact solutions and advance organizational objectives.',
    ],
  },
];

export const ADVISORS = [
  {
    id: 'donna-dasko',
    name: 'Senator Donna Dasko',
    title:
    'The Hon. Senator Donna Dasko PhD — Distinguished Fellow, Munk School of Global Affairs & Public Policy, University of Toronto',
  },
  {
    id: 'tom-hutchinson',
    name: 'Dr. Tom C. Hutchinson',
    title: 'BSc PhD FRSC FRGS — Professor Emeritus, Trent University',
  },
  {
    id: 'krishna-kumar',
    name: 'Dr. Krishna Kumar',
    title: 'Professor of Aerospace, Director of Artificial Intelligence at TMU, and Canada Research Chair in Space Systems',
  },
  {
    id: 'mehdi-sharifi',
    name: 'Dr. Mehdi Sharifi',
    title:
    'PhD Soil Fertility & Nutrient Management — Researcher, Agriculture and Agri-Food Canada, Summerland Research Centre',
  },
  {
    id: 'arunav-misra',
    name: 'Arunav Misra, MEng',
    title: 'Science & Techology Advisor',
  },
];